import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthUserContext } from "../Session";
import { AdminLayout } from "../Admin";

const PrivateAdminRoute = ({ component: Component, ...rest }) => {
  const authUser = useContext(AuthUserContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        authUser ? (
          <AdminLayout authUser={authUser}>
            <Component {...props} />
          </AdminLayout>
        ) : (
          <Redirect to="/signin" />
        )
      }
    />
  );
};

export default PrivateAdminRoute;
